import FJConstant from '../../constants/FJConstant';
import FJUtil from '../../util/FJUtil';

class FJAudioPlayBase {
    _source = null; // 音频Audio标签
    _sourceInfo = null; // 音频源信息
    _sourceUrl = null; // 音频源url

    _sourceBlob = null; // 音频源blob

    // 状态  FJConstant.LOADING 加载中 FJConstant.ERROR 加载错误 FJConstant.SUCCESS 加载成功
    _loadStatus = FJConstant.DEFAULT;
    _isPlaying = false;
    _duration = 0;

    constructor() {}

    /**
     * @desc 跳转到指定时间点
     * @param {Number} time
     */
    async seek(time) {
        if (!this._source) return;
        await new Promise(resolve => {
            this._source.removeEventListener('seeked', this._seekedListener);

            this._seekedListener = () => {
                resolve && resolve(true);
            };
            this._source.addEventListener('seeked', this._seekedListener);

            this._source.currentTime = time;

            if (this._isPlaying) {
                this._playTime = time;
            }
        });
    }

    /**
     * @desc 播放音频
     */
    async play(callback, pauseCallback) {
        if (this._isPlaying) return;
        this._isPlaying = true;
        if (this._source) {
            let requestAnimationTime;
            this._playTime = this._source.currentTime;
            await this._source.play();

            let __playing = timestamp => {
                if (!requestAnimationTime) requestAnimationTime = timestamp;

                this._playTime += (timestamp - requestAnimationTime) / 1000;
                requestAnimationTime = timestamp;

                if (this._playTime >= 0 && this._playTime <= this._duration) {
                    callback && callback(this._playTime);
                }

                if (this._playTime >= this._duration) {
                    this._isPlaying && this.pause();
                    pauseCallback && pauseCallback(this._source.currentTime);
                } else {
                    this._requestTimer = window.requestAnimationFrame(__playing);
                }
            };

            if (this._requestTimer) window.cancelAnimationFrame(this._requestTimer);
            this._requestTimer = window.requestAnimationFrame(__playing);
        }
    }

    /**
     * @desc 暂停音频
     */
    async pause() {
        if (!this._isPlaying || !this._source) return;

        if (this._requestTimer) window.cancelAnimationFrame(this._requestTimer);
        await this._source.pause();
        this._isPlaying = false;
    }

    /**
     * @desc 设置音量
     * @param {Number} volume
     */
    setVolume(volume) {
        this._source.volume = volume;
    }

    /**
     * @desc 设置音频源
     * @param {Object} source
     */
    async setSource(src) {
        try {
            const audio = document.createElement('audio');
            audio.crossOrigin = 'anonymous';
            this._loadStatus = FJConstant.LOADING;
            this._sourceUrl = src;

            const sourceInfo = await new Promise((resolve, reject) => {
                audio.oncanplay = () => {
                    const fileData = {
                        duration: audio.duration,
                    };
                    this._duration = audio.duration;

                    this._loadStatus = FJConstant.SUCCESS;
                    resolve(fileData);
                };
                audio.onerror = () => {
                    this._loadStatus = FJConstant.ERROR;
                    reject();
                };

                audio.src = src;
            });

            this._source = audio;
            this._sourceInfo = sourceInfo;
        } catch (error) {
            this._loadStatus = FJConstant.ERROR;
            throw error;
        }
    }

    /**
     * @desc 获取视频源blob
     * @returns {Promise<Blob>}
     */
    async getSourceBlob() {
        if (this._sourceBlob) return this._sourceBlob;

        const blob = await FJUtil.getBlobByUrl(this._sourceUrl);
        this._sourceBlob = blob;
        return blob;
    }

    clearAll() {
        this.pause();
        this._source = null;
        this._sourceInfo = null;
        this._loadStatus = FJConstant.DEFAULT;
        this._isPlaying = false;
        this._duration = 0;
        this._sourceBlob = null;
    }

    /**
     * @desc 获取音频源信息
     * @returns {Object}
     */
    getSourceInfo() {
        if (!this._sourceInfo) return null;
        return {
            duration: this._duration,
        };
    }

    getCurrentTime() {
        if (!this._source) return 0;
        return this._source.currentTime;
    }

    getIsPlaying() {
        return this._isPlaying;
    }

    getSourceStatus() {
        return this._loadStatus;
    }

    getSourceUrl() {
        return this._sourceUrl;
    }
}

export default FJAudioPlayBase;
